export enum HttpMethods {
  'DELETE' = 'DELETE',
  'GET' = 'GET',
  'HEAD' = 'HEAD',
  'POST' = 'POST',
  'PATCH' = 'PATCH',
  'PUT' = 'PUT',
}
